import API_ENDPOINTS from '../config/apiConfig';
import { api } from './api';

export const getJournalExport = async (filters = {}) => {
  try {
    const { locationId, startDate, endDate, page = 1, pageSize = 25, groupByAccount = false, categories = [], targetCurrency } = filters;

    if (!locationId) throw new Error('locationId is required');
    if (!startDate || !endDate) throw new Error('startDate and endDate are required');

    const queryParams = [
      `locationId=${locationId}`,
      `startDate=${startDate}`,
      `endDate=${endDate}`,
      `page=${page}`,
      `pageSize=${pageSize}`
    ];
    if (groupByAccount) queryParams.push('groupByAccount=true');
    if (categories.length > 0) queryParams.push(`categories=${categories.join(',')}`);
    if (targetCurrency) queryParams.push(`targetCurrency=${encodeURIComponent(targetCurrency)}`);

    const response = await api.get(`${API_ENDPOINTS.JOURNAL_EXPORT}?${queryParams.join('&')}`);
    return response.data;
  } catch (error) {
    console.error('Error in getJournalExport:', error);
    throw error;
  }
};

// Day-level overview: one row per calendar day in range — per-category nets
// (source + adjustments), balance residual, closeout/exported status.
export const getJournalDaySummary = async ({ locationId, startDate, endDate, targetCurrency } = {}) => {
  if (!locationId) throw new Error('locationId is required');
  if (!startDate || !endDate) throw new Error('startDate and endDate are required');
  const params = [
    `locationId=${locationId}`,
    `startDate=${startDate}`,
    `endDate=${endDate}`,
    'summaryByDay=true',
  ];
  if (targetCurrency) params.push(`targetCurrency=${encodeURIComponent(targetCurrency)}`);
  const response = await api.get(`${API_ENDPOINTS.JOURNAL_EXPORT}?${params.join('&')}`);
  return response.data;
};

// Per-account daily debit/credit breakdown for the account detail modal.
export const getAccountDetail = async ({ locationId, startDate, endDate, accountNumber, targetCurrency } = {}) => {
  if (!locationId || !accountNumber) throw new Error('locationId and accountNumber are required');
  const params = [
    `locationId=${locationId}`,
    `startDate=${startDate}`,
    `endDate=${endDate}`,
    `detailAccountNumber=${encodeURIComponent(accountNumber)}`,
  ];
  if (targetCurrency) params.push(`targetCurrency=${encodeURIComponent(targetCurrency)}`);
  const response = await api.get(`${API_ENDPOINTS.JOURNAL_EXPORT}?${params.join('&')}`);
  return response.data;
};

export const getAllJournalExport = async (filters = {}) => {
  try {
    const { locationId, startDate, endDate, groupByAccount = false, categories = [], targetCurrency } = filters;

    if (!locationId) throw new Error('locationId is required');
    if (!startDate || !endDate) throw new Error('startDate and endDate are required');

    const queryParams = [
      `locationId=${locationId}`,
      `startDate=${startDate}`,
      `endDate=${endDate}`,
      `exportAll=true`
    ];
    if (groupByAccount) queryParams.push('groupByAccount=true');
    if (categories.length > 0) queryParams.push(`categories=${categories.join(',')}`);
    if (targetCurrency) queryParams.push(`targetCurrency=${encodeURIComponent(targetCurrency)}`);

    const response = await api.get(`${API_ENDPOINTS.JOURNAL_EXPORT}?${queryParams.join('&')}`);
    return response.data;
  } catch (error) {
    console.error('Error in getAllJournalExport:', error);
    throw error;
  }
};

// "Export to accounting system": the org's configured format (Oracle Fusion
// today), which kinds it offers, whether the SFTP integration is available
// and whether this period was already sent.
export const getAccountingExportInfo = async ({ locationId, year, month } = {}) => {
  if (!locationId || !year || !month) throw new Error('locationId, year and month are required');
  const response = await api.get(`${API_ENDPOINTS.JOURNAL_ACCOUNTING_EXPORT}?locationId=${locationId}&year=${year}&month=${month}`);
  return response.data;
};

// deliver 'download' → { files:[{fileName, content, ...}], warnings } (nothing is marked exported)
// deliver 'sftp'     → pushes through the integration, marks the period exported (409 if already sent)
export const runAccountingExport = async ({ locationId, kind, year, month, deliver } = {}) => {
  const response = await api.post(API_ENDPOINTS.JOURNAL_ACCOUNTING_EXPORT, { locationId, kind, year, month, deliver });
  return response.data;
};
